import { type LoaderFunctionArgs, redirect } from 'react-router';
import { generateGroupInfoQueryOptions } from '@/hooks/groups/use-group-info';
import ROUTES from '@/routes';
import { catchFetcherError } from '@/utils/fetcher';
import { isGroupAdmin } from '@/utils/group';
import { queryClient } from '@/utils/query-client';

export async function groupAdminLayoutLoader({ params }: LoaderFunctionArgs) {
  const { id: groupId } = ROUTES.MESSAGES.GROUPS.SETTINGS.ADMIN.$deserializeParams(params);

  if (!groupId) return redirect(ROUTES.MESSAGES.$path());

  const groupInfo = await queryClient.ensureQueryData(generateGroupInfoQueryOptions(groupId)).catch(catchFetcherError);

  if (groupInfo && !isGroupAdmin(groupInfo)) {
    return redirect(
      ROUTES.MESSAGES.GROUPS.SETTINGS.$buildPath({
        params: {
          id: groupId,
        },
      }),
    );
  }

  return null;
}
